/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:30 GMT
 */
const tokens = {
    component: {
        toast: {
            container: {
                margin: {
                    value: "24px",
                    type: "dimension",
                },
            },
            alert: {
                maxWidth: {
                    value: "480px",
                    type: "dimension",
                },
                borderRadius: {
                    value: "12px",
                    type: "dimension",
                },
                minHeight: {
                    value: "56px",
                    type: "dimension",
                },
                backgroundColor: {
                    value: "#282e37",
                    type: "color",
                },
                paddingTop: {
                    value: "0px",
                    type: "dimension",
                },
                paddingRight: {
                    value: "0px",
                    type: "dimension",
                },
                paddingBottom: {
                    value: "0px",
                    type: "dimension",
                },
                paddingLeft: {
                    value: "0px",
                    type: "dimension",
                },
                gap: {
                    value: "0px",
                    type: "dimension",
                },
                icon: {
                    width: {
                        value: "40px",
                        type: "dimension",
                    },
                    minHeight: {
                        value: "56px",
                        type: "dimension",
                    },
                    paddingTop: {
                        value: "0px",
                        type: "dimension",
                    },
                    paddingBottom: {
                        value: "0px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "0px",
                        type: "dimension",
                    },
                    paddingLeft: {
                        value: "0px",
                        type: "dimension",
                    },
                    borderRadius: {
                        value: "12px",
                        type: "dimension",
                    },
                    success: {
                        backgroundColor: {
                            value: "#8ee400",
                            type: "color",
                        },
                    },
                    info: {
                        backgroundColor: {
                            value: "#1dd9f9",
                            type: "color",
                        },
                    },
                    warning: {
                        backgroundColor: {
                            value: "#fee400",
                            type: "color",
                        },
                    },
                    error: {
                        backgroundColor: {
                            value: "#ff99c4",
                            type: "color",
                        },
                    },
                    processing: {
                        backgroundColor: {
                            value: "#dadada",
                            type: "color",
                        },
                        minHeight: {
                            value: "56px",
                            type: "dimension",
                        },
                        paddingTop: {
                            value: "0px",
                            type: "dimension",
                        },
                        paddingBottom: {
                            value: "0px",
                            type: "dimension",
                        },
                        paddingRight: {
                            value: "0px",
                            type: "dimension",
                        },
                        paddingLeft: {
                            value: "0px",
                            type: "dimension",
                        },
                    },
                },
                action: {
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                    paddingTop: {
                        value: "8px",
                        type: "dimension",
                    },
                    paddingBottom: {
                        value: "8px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "16px",
                        type: "dimension",
                    },
                    paddingLeft: {
                        value: "16px",
                        type: "dimension",
                    },
                    borderTopColor: {
                        value: "#6f7377",
                        type: "color",
                    },
                },
                message: {
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                    paddingTop: {
                        value: "16px",
                        type: "dimension",
                    },
                    paddingBottom: {
                        value: "16px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "16px",
                        type: "dimension",
                    },
                    paddingLeft: {
                        value: "16px",
                        type: "dimension",
                    },
                },
                title: {
                    fontSize: {
                        value: "1.375rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 600,
                        type: "number",
                    },
                    lineHeight: {
                        value: "1.75rem",
                        type: "dimension",
                    },
                    letterSpacing: {
                        value: "0px",
                        type: "dimension",
                    },
                },
            },
        },
    },
};
export default tokens;
